var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("system-custom-notifications-step", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("talent-filtering", {
              key: "talent-filtering-custom-notifications",
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "sidebar",
        fn: function () {
          return [
            _c("h2", [
              _vm._v(
                "Selected " +
                  _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search",
                },
              ],
              attrs: { placeholder: "Filter..." },
              domProps: { value: _vm.search },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.search = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("DynamicScroller", {
              staticClass: "scroller",
              attrs: {
                items: _vm.filteredSelectedStars,
                "min-item-size": 30,
                "key-field": "id",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ item, active }) {
                    return [
                      _c(
                        "DynamicScrollerItem",
                        {
                          attrs: {
                            item: item,
                            active: active,
                            "size-dependencies": [item.name],
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "user",
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemoveTalentCallback(item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(item.name) + " "
                              ),
                              _c("i", {
                                staticClass: "fa fa-times",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRemoveTalentCallback(item)
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }